import React from "react";
import { Button} from "../../../_components";

export default function Buttons({ shopUrl, translation, giftCard }) {


  const goToShop = () => {
    window.open(`https://${shopUrl}/?discount=${giftCard.issued_gift_card_code}`, "_blank");
  }

  return (
      <div className="gc__details_button_wrapper">
      <Button
        type={"button"}
        fullWidth={true}
        onClick={goToShop}
      >
      {
        translation && translation.landing.start_shopping_button_label
        ?
        translation.landing.start_shopping_button_label
        :
        "Start shopping blh nfidos"
      }
      </Button>


    </div>
  )
}
